import SuccessorBorrowerEdit from './SuccessorBorrowerEdit';

export default SuccessorBorrowerEdit;
